import React from 'react';
import Button from './Button';

interface CookieBannerProps {
  onAccept: () => void;
  onLearnMore: () => void;
}

const CookieBanner: React.FC<CookieBannerProps> = ({ onAccept, onLearnMore }) => {
  return (
    <div className="fixed bottom-0 inset-x-0 z-50 bg-white shadow-lg border-t border-gray-200 p-4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between">
        <p className="text-gray-600 mb-4 sm:mb-0 text-center sm:text-left">
          We use cookies to improve your experience, personalize content, and analyze our traffic. 
          By using our site, you agree to our use of cookies.
        </p>
        <div className="flex space-x-4">
          <Button variant="outline" size="sm" onClick={onLearnMore}>
            Learn more
          </Button>
          <Button variant="primary" size="sm" onClick={onAccept}>
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;